import React, { Component } from 'react';
import './App.css';
import '../node_modules/font-awesome/css/font-awesome.min.css';
import Header from './Header';
import Loading from './Loading';
import LocalDataFetcher from './LocalDataFetcher';
import CachedModeDataFetcher from './CachedModeDataFetcher';
import ModeDataManager from './ModeDataManager';
import Scorecard from './Scorecard';

class App extends Component {

  constructor(props) {
      super(props);

      //
      // DEBUG HOOKS
      //
      this.debugMode = true;
      this.useLocalData = false;

      // LOCAL
      //this.cachedUrl = "http://localhost:9092/v1/client-health/data";
      // 52 WEEK
      this.cachedUrl = "https://ops.curalate.com/v1/client-health/data?key=52week-sparse/mode_data.json.gz";
      // PROD
      //this.cachedUrl = "https://ops.curalate.com/v1/client-health/data";

      this.local = window.location.hostname.toLowerCase() === "localhost";

      this.notSignedIn = false;
      this.errors = [];
      this.state = {
          dataRetrieved: 0, //0 = outstanding, 1 = retrieved, -1 = error
      };

      this.mdm = null;
  }

  componentDidMount() {

      let dataFetcher = null;
      if (this.useLocalData && this.local) {
          console.log("Using Local Data!!!");
          dataFetcher = new LocalDataFetcher();
      } else {
          dataFetcher = new CachedModeDataFetcher(this.cachedUrl)
      }

      this.mdm = new ModeDataManager(dataFetcher);
      const prepareDataFuture = this.mdm.prepareData().then(notUsed => {
          this.setState({dataRetrieved: 1});
      });

      if (!this.local || !this.debugMode) {
          prepareDataFuture.catch(err => {

              if (err.stack && err.stack === "TypeError: Failed to fetch") {
                  this.notSignedIn = true;
                  this.setState({dataRetrieved: -1});
              } else {
                  this.errors.push(err);
                  console.error(err);
                  this.setState({dataRetrieved: -1});
              }
          });
      }
  }

  render() {
      let content = null;
      if (this.state.dataRetrieved < 1) {
          let additionalContent = null;
          if (this.notSignedIn) {
            additionalContent =
                <div className="uk-container bold margin-bottom">
                    <span>It appears that you not signed in. Please sign in </span>
                    <a href="https://ops.curalate.com" target="_blank" rel="noopener noreferrer">here</a>
                    <span> and refresh the page</span>
                </div>
          } else if (this.errors.length > 0) {
              additionalContent =
                <div>
                  {this.errors[0].toString()}
                </div>
          }

          content =
                <Loading isError={this.state.dataRetrieved < 0}>
                    {additionalContent}
                </Loading>
      } else {
          content = <Scorecard dataManager={this.mdm} />;
      }

      return (
          <div style={{minWidth: "1250px"}}>
              <Header />
              {content}
          </div>
      )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js